<app-dialog [dialogWithInput]="dialog">
    <app-card>
        <p [innerHTML]="dialog.input.textAsHtml"></p>
    </app-card>
</app-dialog>